// -> IPublicationManager (DecksController). UC-9..UC-13, UC-24.
//
// PublishAsync is `POST /api/decks/publish`, not `POST /api/decks/:id/publish` - there is no id
// to address until the publish succeeds (D-212 item 1, DecksController.cs).
import { http } from "./http";
import type {
  ArtifactFormat,
  ArtifactRef,
  DeckGenerateRequest,
  DeckPreview,
  DeckPublishRequest,
  DeckVersionDetail,
  DeckVersionState,
  DeckVersionSummary,
  PagedResult,
  VersionDiff,
} from "./generated/contracts";

export interface ListVersionsParams {
  readonly state?: DeckVersionState;
  readonly reportDateFrom?: string;
  readonly reportDateTo?: string;
  readonly titleContains?: string;
  readonly pageNumber?: number;
  readonly pageSize?: number;
}

export const publicationApi = {
  listVersions: (params: ListVersionsParams = {}) =>
    http.get<PagedResult<DeckVersionSummary>>("/api/decks", { query: { ...params } }),

  getVersion: (versionKey: string) => http.get<DeckVersionDetail>(`/api/decks/${versionKey}`),

  generate: (request: DeckGenerateRequest) => http.post<DeckPreview>("/api/decks/generate", { body: request }),

  publish: (request: DeckPublishRequest) => http.post<DeckVersionSummary>("/api/decks/publish", { body: request }),

  finalize: (versionKey: string) => http.post<DeckVersionSummary>(`/api/decks/${versionKey}/finalize`),

  reExport: (versionKey: string, format: ArtifactFormat) =>
    http.post<ArtifactRef>(`/api/decks/${versionKey}/exports`, { query: { format } }),

  compare: (baseline: string, comparand: string) =>
    http.get<VersionDiff>("/api/decks/diff", { query: { baseline, comparand } }),
};
